function init() {
	subMenuVisibility();
	scrollDown();
	headerSearchModal();
	headerPrimaryMenu();

	window.addEventListener("resize", () => {
		scrollDown();
	});

	menuVisibility();
	langMenuVisibility();
}

function scrollDown() {
	var scrollDown = document.querySelector(".scroll-down");

	if (scrollDown) {
		scrollDown.addEventListener("click", function () {
			window.scrollTo({
				top: window.innerHeight,
				behavior: "smooth",
			});
		});
	}
}

function headerSearchModal() {
	var modal = document.getElementById("header-search-modal");
	var openButtons = document.querySelectorAll("[data-header-search-open]");

	if (!modal || !openButtons.length) {
		return;
	}

	var closeButtons = modal.querySelectorAll("[data-header-search-close]");
	var searchInput = modal.querySelector(".dgwt-wcas-search-input, input[type='search'], input[type='text']");
	var previouslyFocused = null;

	function openModal(button) {
		previouslyFocused = document.activeElement;
		modal.hidden = false;
		window.requestAnimationFrame(function () {
			modal.classList.add("is-open");
			document.documentElement.classList.add("noscroll");
			button.setAttribute("aria-expanded", "true");

			if (searchInput) {
				searchInput.focus();
			}
		});
	}

	function closeModal() {
		modal.classList.remove("is-open");
		document.documentElement.classList.remove("noscroll");

		openButtons.forEach(function (button) {
			button.setAttribute("aria-expanded", "false");
		});

		window.setTimeout(function () {
			modal.hidden = true;

			if (previouslyFocused && typeof previouslyFocused.focus === "function") {
				previouslyFocused.focus();
			}
		}, 250);
	}

	openButtons.forEach(function (button) {
		button.addEventListener("click", function () {
			openModal(button);
		});
	});

	closeButtons.forEach(function (button) {
		button.addEventListener("click", closeModal);
	});

	document.addEventListener("keydown", function (event) {
		if (!modal.hidden && event.key === "Escape") {
			closeModal();
		}
	});
}

function headerPrimaryMenu() {
	var menuWrapper = document.querySelector(".primary-navigation-wrapper");
	var openButtons = document.querySelectorAll("[data-header-menu-open]");

	if (!menuWrapper || !openButtons.length) {
		return;
	}

	var closeButtons = menuWrapper.querySelectorAll("[data-header-menu-close]");
	var previouslyFocused = null;

	function resetDrillDown() {
		menuWrapper
			.querySelectorAll(".is-drill-current, .menu-item-has-children.active")
			.forEach(function (item) {
				item.classList.remove("is-drill-current", "active");
			});

		var primaryMenu = menuWrapper.querySelector("#primary-menu");
		if (primaryMenu) {
			primaryMenu.classList.remove("is-drilling");
		}

		menuWrapper
			.querySelectorAll(".menu-item-has-children > a[aria-expanded]")
			.forEach(function (link) {
				link.setAttribute("aria-expanded", "false");
			});
	}

	function openMenu() {
		previouslyFocused = document.activeElement;
		menuWrapper.classList.add("is-mobile-open");
		document.documentElement.classList.add("noscroll");
		openButtons.forEach(function (openButton) {
			openButton.setAttribute("aria-expanded", "true");
		});

		var firstLink = menuWrapper.querySelector("a, button");
		if (firstLink) {
			firstLink.focus();
		}
	}

	function closeMenu() {
		menuWrapper.classList.remove("is-mobile-open");
		document.documentElement.classList.remove("noscroll");
		resetDrillDown();
		openButtons.forEach(function (openButton) {
			openButton.setAttribute("aria-expanded", "false");
		});

		if (previouslyFocused && typeof previouslyFocused.focus === "function") {
			previouslyFocused.focus();
		}
	}

	openButtons.forEach(function (button) {
		button.addEventListener("click", function () {
			openMenu();
		});
	});

	closeButtons.forEach(function (button) {
		button.addEventListener("click", closeMenu);
	});

	document.addEventListener("keydown", function (event) {
		if (menuWrapper.classList.contains("is-mobile-open") && event.key === "Escape") {
			closeMenu();
		}
	});
}

function menuVisibility() {
	var mainHeader = document.getElementById("main-header");

	window.addEventListener("scroll", function () {
		var scrollTop = document.documentElement.scrollTop;
		if (scrollTop >= 150) {
			mainHeader.classList.add("scrolled");
		} else {
			mainHeader.classList.remove("scrolled");
		}
	});

	var lastScrollTop = 0;

	window.addEventListener(
		"scroll",
		function () {
			var scrollTop = document.documentElement.scrollTop;

			if (scrollTop >= 150) {
				mainHeader.classList.add("scrolled");
				mainHeader.addEventListener(
					"transitionend",
					function () {
						if (!mainHeader.classList.contains("has-scrolled")) {
							mainHeader.classList.add("has-scrolled");
						}
					},
					{
						once: true,
					}
				);
			} else {
				mainHeader.classList.remove("scrolled");
				mainHeader.addEventListener(
					"transitionend",
					function () {
						if (mainHeader.classList.contains("has-scrolled")) {
							mainHeader.classList.remove("has-scrolled");
						}
					},
					{
						once: true,
					}
				);
			}

			if (scrollTop < lastScrollTop) {
				mainHeader.classList.add("scroll-up");
				document.body.classList.add("scroll-up");
			} else {
				mainHeader.classList.remove("scroll-up");
				document.body.classList.remove("scroll-up");
			}

			lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
		},
		false
	);
}

function subMenuVisibility() {
	var mobileMenu = window.matchMedia("(max-width: 767.98px)");
	var primaryMenu = document.getElementById("primary-menu");
	var hasChildrenItems = document.querySelectorAll(
		"#primary-menu .menu-item-has-children > a"
	);

	function ensureBackButton(subMenu) {
		if (!subMenu || subMenu.querySelector(":scope > .smx-drill-back")) {
			return;
		}

		var backItem = document.createElement("li");
		backItem.className = "smx-drill-back";

		var backButton = document.createElement("button");
		backButton.type = "button";
		backButton.textContent = (window.smxI18n && window.smxI18n.back) || "Indietro";
		backButton.addEventListener("click", function () {
			var parentItem = subMenu.closest(".menu-item-has-children");
			if (parentItem) {
				parentItem.classList.remove("is-drill-current");
			}

			var parentLink = parentItem ? parentItem.querySelector(":scope > a") : null;
			if (parentLink) {
				parentLink.setAttribute("aria-expanded", "false");
			}

			if (primaryMenu && !primaryMenu.querySelector(".is-drill-current")) {
				primaryMenu.classList.remove("is-drilling");
			}

			if (parentLink) {
				parentLink.focus();
			}
		});

		backItem.appendChild(backButton);
		subMenu.insertBefore(backItem, subMenu.firstChild);
	}

	if (hasChildrenItems.length > 0) {
		window.utils.forEach(hasChildrenItems, function (index, hasChildrenItem) {
			ensureBackButton(hasChildrenItem.parentElement.querySelector(":scope > .sub-menu"));
			hasChildrenItem.setAttribute("aria-expanded", "false");

			hasChildrenItem.addEventListener("click", function (e) {
				e.preventDefault();

				if (!mobileMenu.matches) {
					var isActive = hasChildrenItem.parentElement.classList.toggle("active");
					hasChildrenItem.setAttribute("aria-expanded", isActive ? "true" : "false");
					return;
				}

				if (primaryMenu) {
					primaryMenu.classList.add("is-drilling");
				}

				hasChildrenItem.parentElement.classList.add("is-drill-current");
				hasChildrenItem.setAttribute("aria-expanded", "true");
				var backButton = hasChildrenItem.parentElement.querySelector(".smx-drill-back button");
				if (backButton) {
					backButton.focus();
				}
			});
		});
	}
}

function langMenuVisibility() {
	var langToggler = document.querySelector(
		"#lang-menu .menu-item-has-children > a"
	);

	if (langToggler) {
		langToggler.addEventListener("click", function (e) {
			e.preventDefault();
			langToggler.parentElement.parentElement.classList.toggle("open");
		});
	}
}

window.menuToggle = function (elem) {
	if (elem) {
		console.log(elem);

		var htmlTag = document.getElementsByTagName("html")[0],
			mainHeader = document.getElementById("main-header"),
			menuWrapper = document.querySelector(elem),
			menuToggler = document.getElementById("primary-nav-toggler");

		menuToggler.classList.toggle("hide");
		htmlTag.classList.toggle("noscroll");
		mainHeader.classList.toggle("active");
		menuWrapper.classList.toggle("visible");
	}
};

export default { init };
